module.exports = __webpack_public_path__ + "img/7.abef0808.png";